import { CooperativasUsuarioResponse } from 'api/Assessor/usuario';

interface FiltrosState {
  cooperativas: CooperativasUsuarioResponse;
  loading: boolean;
  coop: string | undefined;
  startDate: Date;
  endDate: Date;
  search: string;
}

type FiltrosActionTypes =
  | 'setCooperativas'
  | 'setCoop'
  | 'setLoading'
  | 'setStartDate'
  | 'setEndDate'
  | 'setSearch';

interface FiltrosAction {
  type: FiltrosActionTypes;
  value?: any;
}

const initialStartDate = new Date('10/01/2020');

export const filtrosInitialState: FiltrosState = {
  cooperativas: [],
  coop: undefined,
  loading: false,
  startDate: initialStartDate,
  endDate: new Date(),
  search: '',
};

export const filtrosReducer = (
  state: FiltrosState,
  action: FiltrosAction
): FiltrosState => {
  switch (action.type) {
    case 'setCooperativas':
      return { ...state, cooperativas: action.value };
    case 'setCoop':
      return { ...state, coop: action.value };
    case 'setLoading':
      return { ...state, loading: action.value };
    case 'setStartDate':
      return { ...state, startDate: action.value };
    case 'setEndDate':
      return { ...state, endDate: action.value };
    case 'setSearch':
      return { ...state, search: action.value };
    default:
      return state;
  }
};
